import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider, useAuth } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";

import Nav from "@/components/Nav";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import EventWizard from "@/pages/EventWizard";
import EventDetail from "@/pages/EventDetail";
import GuestAccess from "@/pages/GuestAccess";
import GuestEvent from "@/pages/GuestEvent";
import Admin from "@/pages/Admin";
import Demo from "@/pages/Demo";
import JewelerPanel from "@/pages/JewelerPanel";
import JewelerDemo from "@/pages/JewelerDemo";
import MemoryDemo from "@/pages/MemoryDemo";

function Protected({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="mx-auto max-w-7xl px-4 py-16 text-muted-foreground">...</div>;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (role && user.role !== role) return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  React.useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="App min-h-screen bg-background text-foreground relative">
            <Nav />
            <main className="relative z-10">
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/demo" element={<Demo />} />
                <Route path="/demo/jeweler" element={<JewelerDemo />} />
                <Route path="/demo/memory" element={<MemoryDemo />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
                <Route path="/events/new" element={<Protected><EventWizard /></Protected>} />
                <Route path="/events/:id" element={<Protected><EventDetail /></Protected>} />
                <Route path="/admin" element={<Protected role="super_admin"><Admin /></Protected>} />
                <Route path="/jeweler" element={<Protected role="jeweler"><JewelerPanel /></Protected>} />
                <Route path="/g" element={<GuestAccess />} />
                <Route path="/g/:key" element={<GuestAccess />} />
                <Route path="/g/:key/live" element={<GuestEvent />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Toaster position="top-center" richColors theme="dark" />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
